
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/events/[slug]",
      function () {
        return require("private-next-pages/[domain]/events/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/events/[slug]"])
      });
    }
  